// extracted by mini-css-extract-plugin
export default {"assortment":"hGvXj","imageContainer":"Sb93D","image":"s0UbI","textBlock":"J4HJh","title":"hu813","text":"P8v2B"};